import { TextFieldProps } from '@mui/material/TextField';

export type ValueWrapperObject<T extends Record<string, unknown>> = {
  fields: { [K in keyof T]: ValueWrapper<T[K]> };
  title: string;
};

export type ValueWrapper<T> = T extends Record<string, unknown>
  ? ValueWrapperObject<T>
  : T extends string | number | Date
  ? ValueWrapperText<T>
  : T extends Array<infer U>
  ? ValueWrapperArray<U>
  : ValueWrapperBoolean;

export type ValueWrapperText<T extends string | number | Date> = {
  value?: T extends string ? string : T;
  regex?: RegExp;
  regexExplained?: string;
} & Omit<TextFieldProps, 'onChange'>;

export type ValueWrapperArray<U = unknown> = {
  element: ValueWrapper<U>;
  title: string;
  initialElements?: ValueWrapper<U>[];
};

export type ValueWrapperBoolean = {
  value: boolean;
  label: string;
};

export function unwrapValue<U>(input: ValueWrapper<U>): U {
  if ('value' in input) {
    return input.value as U;
  }
  if ('element' in input) {
    return unwrapValue(input.element) as U;
  }
  if ('fields' in input) {
    const keys = Object.keys(input.fields);

    const result = keys.reduce((acc, key) => {
      acc[String(key)] = unwrapValue(input.fields[String(key)]);
      return acc;
    }, {} as Record<string, unknown>);

    return result as U;
  } else {
    throw new Error('Invalid input type in unwrapValue function.');
  }
}
